import Button from '../Button';
import Typography, { TypographyStyle } from '../Typography/Typography';
import clsx from 'clsx';
import { Link } from '~/shared/components';
import { useMemo } from 'react';
import styles from './HeroContent.module.scss';
import { CustomCSSProperties } from '~/templates/blocks/components/M11Hero/M11Hero';
import { useButtonVariant } from '../Button/useButtonVariant';

interface HeroContentProps {
    trumpet?: string;
    title?: string;
    titleSize?: string;
    paragraphText?: string;
    link?: {
        text?: string;
        title?: string;
        url?: string;
        id?: string;
        target?: string;
    };
    foregroundColor: string;
    customProperties?: CustomCSSProperties;
    noMedia?: boolean;
}

export const HeroContent = ({
    trumpet,
    paragraphText,
    link,
    title,
    foregroundColor,
    titleSize,
    customProperties,
    noMedia,
}: HeroContentProps) => {
    const headingVariant = useMemo<TypographyStyle>(() => {
        switch (titleSize) {
            case 'Medium':
                return 'title-L';
            case 'Large':
                return 'display-L';
            case 'Extra Large':
                return 'display-XL';
        }

        return 'title-L';
    }, [titleSize]);

    const buttonVariant = useButtonVariant('Default', foregroundColor);

    return (
        <div
            className={clsx(styles.content, {
                [styles.noImage]: noMedia,
            })}
            style={customProperties}
        >
            {trumpet && <span className={styles.trumpet}>{trumpet}</span>}

            {title && (
                <Typography
                    className={clsx(styles.title, {
                        [styles.noParagraph]: !paragraphText,
                        [styles.noSpace]: !paragraphText || !link?.text,
                        [styles.withButton]: !paragraphText && link?.text,
                    })}
                    variant={headingVariant}
                    as="h2"
                >
                    <span>{title}</span>
                </Typography>
            )}

            {paragraphText && (
                <div
                    className={clsx(styles.paragraph, {
                        [styles.noSpace]: !link?.text,
                    })}
                    dangerouslySetInnerHTML={{ __html: paragraphText }}
                />
            )}

            {link?.text && link?.url && (
                <Button
                    variant={buttonVariant}
                    title={link.title}
                    as={Link}
                    target={link.target}
                    href={link.url}
                    children={link.text}
                    className={clsx(styles.cta, 'hoverShadowStyle')}
                />
            )}
        </div>
    );
};
